var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEquipmentPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 108,
    viewBox: "0 0 288 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 10.5,
    width: 87,
    height: 87,
    rx: 43.5,
    fill: "#F7F7F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 10.5,
    width: 87,
    height: 87,
    rx: 43.5,
    stroke: "#CECEDA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M138.5 31.5V40.5H135.5V31.5C135.562 30.5625 136.062 30.0625 137 30C137.938 30.0625 138.438 30.5625 138.5 31.5ZM153.5 31.5V40.5H150.5V31.5C150.562 30.5625 151.062 30.0625 152 30C152.938 30.0625 153.438 30.5625 153.5 31.5ZM128 43.5H129.5H132.5H156.5H159.5H161C161.938 43.5625 162.438 44.0625 162.5 45C162.438 45.9375 161.938 46.4375 161 46.5H159.5V52.5C159.438 56.5 158.125 59.875 155.562 62.625C153.062 65.375 149.875 66.9688 146 67.4062V76.5C145.938 77.4375 145.438 77.9375 144.5 78C143.562 77.9375 143.062 77.4375 143 76.5V67.4062C139.125 66.9688 135.938 65.375 133.438 62.625C130.875 59.875 129.562 56.5 129.5 52.5V46.5H128C127.062 46.4375 126.562 45.9375 126.5 45C126.562 44.0625 127.062 43.5625 128 43.5ZM144.5 64.5C147.875 64.4375 150.719 63.2812 153.031 61.0312C155.281 58.7188 156.438 55.875 156.5 52.5V46.5H132.5V52.5C132.562 55.875 133.719 58.7188 135.969 61.0312C138.281 63.2812 141.125 64.4375 144.5 64.5Z",
    fill: "#706B85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipmentPlaceholder);
export default __webpack_public_path__ + "static/media/equipment-placeholder.fa72ae362339ea4d8f0027896112d74c.svg";
export { ForwardRef as ReactComponent };